export default {
  acronym: '',
  agreedSchedule: false,
  arrivalBreakTolerance: 0,
  beginExceptionalWorkday: '',
  collationTime: true,
  contractIds: [],
  contracts: [],
  departureBreakTolerance: 0,
  description: '',
  exceptionalWorkday: false,
  expirationExceptionalWorkday: '',
  exitTolerance: 0,
  flexibleShift: false,
  imputableColation: false,
  initialTime: '',
  lunchCheck: false,
  lunchTime: '',
  maximumStartTime: '',
  name: '',
  autorenew: '0',
  shiftDaysAttributes: [],
  shiftExtension: 'weekly_extension',
  shiftType: 'weekly',
  startDate: '',
  tolerance: 0,
  weekends: false,
  workHolidays: false,
  workHours: '',
  workdayNumber: '',
  exceptionalShiftCycle: ''
};
